import React from 'react';

import { DragDropProvider, Droppable, Draggable } from '../dnd';
import { Box, Flex, Text } from 'rebass';
import { recursivelyGetChildren, updateNestedNodes } from '../dnd/helpers';

let questionNumber = 0;
let numNested = 8;
const outlineList = {};
Array.from(Array(numNested)).map((_, i) => {
  const previousId = questionNumber;
  const id = questionNumber++;
  
  outlineList[`layer-${id}`] = {
    id: `layer-${id}`,
    name: `Layer ${id}`,
    icon: '📦',
    parent: previousId === 0 ? 'root' : `layer-${previousId - 1}`,
    index: 0,
  };

  if (id === numNested - 1) {
    Array.from(Array(10)).map((_, j) => {
      const id = questionNumber++;
      outlineList[`layer-${id}`] = {
        id: `layer-${id}`,
        name: `Layer ${id}`,
        icon: '📦',
        parent: previousId === 0 ? 'root' : `layer-${previousId - 1}`,
        index: j + 1,
      };
    });
  }
});

const DeepNested = ({ showDebug, shouldAnimate }) => {
  const [nodes, setNodes] = React.useState(outlineList);

  const handleDragEnd = ({ id, from, to }) => {
    setNodes(n => {
      return updateNestedNodes(n, id, from ,to);
    });
  };

  const createNestedContent = (items, parentItem) => {
    return (
      <Droppable droppableId={(parentItem && parentItem.id) || 'root'}>
        {(provided, snapshot) => (
          <Flex
            flexDirection="column"
            ref={provided.innerRef}
            {...provided.droppableProps}
            css={`
              background: ${snapshot.isDraggingOver ? 'var(--hoveringHighlight)' : 'undefined'};
              border-radius: 8px;
              text-align: left;
              min-height: 40px;
            `}
          >
            {items.map((item, index) => (
              <Draggable key={item.id} draggableId={item.id} index={index} type={item.type}>
                {(provided, snapshot) => (
                  <Box
                    p={2}
                    pr={0}
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    css={`
                      border: 1px solid ${snapshot.isDragging ? 'var(--hoveringHighlightBorder)' : 'var(--border)'};
                      border-radius: 8px;
                      border-top-right-radius: 0;
                      border-bottom-right-radius: 0;
                      border-right: none;
                      background: var(--nestedBackground);
                      ${snapshot.hoveringDroppableId === item.id ? 'border-color: var(--hoveringHighlightBorderMuted);' : ''}
                    `}
                  >
                    <Flex alignItems="center" mb={item.children ? 2 : null}>
                      <Text
                        fontSize={0}
                        css={`
                          width: 1.7em;
                          height: 1.7em;
                          text-align: center;
                        `}
                      >
                        {item.icon}
                      </Text>
                      <Text ml={2} fontSize={1}>{item.name}</Text>
                    </Flex>
                    <Box ml={1}>
                      {item.children ? createNestedContent(item.children, item) : null}
                    </Box>
                  </Box>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </Flex>
        )}  
      </Droppable>
    );
  };

  return (
    <DragDropProvider
      onDragEnd={handleDragEnd}
      showDebug={showDebug}
      shouldAnimate={shouldAnimate}
    >
      {() => (
        <Box css="max-width: 400px; margin: 0 auto;">
          <Text mb={2}>Layers</Text>
          <Box
            p={3}
            bg="var(--background-alt)"
            css={`
              border-radius: 8px;
            `}
          >
            {createNestedContent(recursivelyGetChildren(nodes, 'root'))}
          </Box>
        </Box>
      )}
    </DragDropProvider>
  );
};

export default DeepNested;
